module.exports = __webpack_public_path__ + "static/logo-e4dff84f16077a9c8cc6387e1758925e.svg";